export const validateEmail = (email: string) => {
	// eslint-disable-next-line no-useless-escape
	return RegExp(
		/^([A-Za-z0-9_\-+.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,63})$/
	).exec(email);
};
